import {
    GraphQlClient,
  } from '@intelipost-js/secure-providers';


export default {
  getTableGereratedQuoteContract({ commit }, params) {
    commit('toggleLoading', true);

    return GraphQlClient.query(`
      query {
        tableQuoteContracts {
          contract_id
          delivery_method_id
          download_url
          file_name
        }
      }`, params)
      .then(({ data = {} }) => {
        const { tableQuoteContracts = {} } = data || {};
        commit('toggleLoading', false);
        commit('setTableGereratedQuoteContract', tableQuoteContracts);
        return Promise.resolve(data);
      }).catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-quote/features/table-quote/store/actions.js